<template>
  <div>
      内容待定
  </div>
</template>

<script>

export default {
    name: 'dashboard',
    data() {
        return {}
    },
    methods: {}
};
</script>


<style scoped lang="less">

</style>
